import {HttpException} from "./http.exception.js";

/**
 * 405 Method Not Allowed Exception
 */
export class MethodNotAllowedException extends HttpException {
    constructor(message: string = "Method Not Allowed", errorBody?: unknown, cause?: Error) {
        super(405, message, errorBody, cause);
    }
}
